import { NavLink } from "react-router-dom";
// import Logo from "@/components/Logo";
import Logo from "../Assets/Logo.png";
import UseScrollAnimation from "./ScrollAnimation";
import whatappIcon from "../Assets/WhatsappIcon1.png";
import { ArrowUp } from "lucide-react";
import { Mail, Phone, MapPin } from "lucide-react";

import {
  FaFacebook,
  FaInstagram,
  // FaLinkedin,
  // FaTiktok,
  // FaYoutube,
  // FaTwitter,
} from "react-icons/fa";

const SiteFooter = () => {
  const year = new Date().getFullYear();
  UseScrollAnimation(); // ✅ just call it

  // Scroll to the top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll
    });
  };
  return (
    <footer className="FooterParent">
      <div className="FooterBox">
        <div className="FooterContentParent">
          <div className="FooterContentBox">
            <div className="FooterLogoContent">
              <div className="FooterLogoDiv">
                <img src={Logo} alt="Logo" className="FooterLogo" />
              </div>
              <span className="FooterLogoContentDiv">
                <span className="FooterLogoContentTop">
                  The Wellness Destination
                </span>
                <span className="FooterLogoContentBottom">Homeopathy, LLC</span>
              </span>
            </div>
            <p className="FooterLogoContentBox_Content">
              Classical homeopathy and whole-person wellness care. Gentle
              remedies, profound healing.
            </p>
            <div className="Header_SocialMedia_BoxDiv">
              <span className="Header_SocialMedia_BoxDivSpan">
                <a
                  href="https://www.instagram.com/p/DXSfegnDtY0/?img_index=3&igsh=MTBpcmsxZmh5YmZrMQ=="
                  className="Header_Section_SMIcon_aTag"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaInstagram className="Header_Section_SMIcon" />
                </a>
                <a
                  href="#!"
                  className="Header_Section_SMIcon_aTag"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebook className="Header_Section_SMIcon" />
                </a>
              </span>
            </div>
          </div>

          <div className="FooterContentBox FooterContentBox00">
            <span className="FooterContentBox_Heading">Resources</span>
            <ul className="FooterContentBox_UL">
              {[
                { to: "/client-forms", label: "Client Forms" },
                { to: "/privacy-policy", label: "Privacy Policy" },
                { to: "/terms-and-conditions", label: "Terms and Conditions" },
                { to: "/disclaimer", label: "Disclaimer" },
              ].map((l) => (
                <NavLink
                  key={l.to} // ✅ unique key added
                  onClick={scrollToTop}
                  to={l.to}
                  className={({ isActive }) =>
                    `WebsiteFooterMenuListDiv_MenuList ${
                      isActive ? "activeMenu" : ""
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
            </ul>
          </div>

          <div className="FooterContentBox FooterContentBox00">
            <span className="FooterContentBox_Heading">Contact</span>
            <ul className="FooterContentBox_UL">
              <a href="tel:+16104127940" className="contact_link">
                <Phone className="Footer_Section_HighestIcon" />
                <li>(610) 412-7940</li>
              </a>
              <a href="mailto:infotwdhomeo@gmail.com" className="contact_link">
                <Mail className="Footer_Section_HighestIcon" />
                <li>infotwdhomeo@gmail.com</li>
              </a>
              {/* <a href="mailto:info@twdhomeo.com" className="contact_link">
                <Mail className="Footer_Section_HighestIcon" />
                <li>info@twdhomeo.com</li>
              </a> */}
              {/* <a
                href="wellnessdestinationhomeopathy@gmail.com"
                className="contact_link"
              >
                <li>wellnessdestinationhomeopathy@gmail.com</li>
              </a> */}
              <a
                href="https://www.google.com/maps?q=Suite+106-H+801+Springdale+Dr+Exton,+PA+19341"
                className="contact_link"
                target="_black"
              >
                <MapPin className="Footer_Section_HighestIcon" />
                <li>
                  Suite: 106-H <br />
                  801 Springdale Dr <br />
                  Exton, PA 19341
                </li>
              </a>
              <li>By appointment only</li>
              <li>
                <NavLink
                  to="/contact-us"
                  className="underline-offset-4 hover:underline"
                  onClick={scrollToTop}
                >
                  Send a message →
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <span className="Footer_HR"> </span>
      <div className="Footer_CopyRights">
        <p>
          © {year}{" "}
          <a
            href="https://staiminds.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="staiminds"
          >
            ST AI Minds
          </a>
          . All rights reserved.
        </p>
        <a
          href="https://www.linkedin.com/in/pandugayala-raja-naresh-b15b4986/"
          className="Developer"
          target="_blank"
          rel="noreferrer"
        >
          Crafted by: Pandugayala Raja Naresh | Web Developer
        </a>
        <div className="goTop" onClick={scrollToTop}>
          {/* <span>TOP</span> */}
          <ArrowUp className="goTopIcon" />
        </div>
        <div className="WhatApp">
          <a
            href="https://wa.link/oti0pc"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={whatappIcon} alt="whatappIcon" className="whatappIcon" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
